/**
 * Maximum number of items a graphQL query will fetch
 */
export const MAX_ITEMS_PER_QUERY = 1000

/**
 * Time window used for calculation fees APR
 */
export const SWAP_FEE_WINDOW = 3600 * 24
